import { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import { track } from "@/lib/analytics";
import BusinessBriefing from "@/app/BusinessBriefing";
import WorkspacePulse from "@/app/WorkspacePulse";
import CommandCenterAnalytics from "@/app/CommandCenterAnalytics";
import AIChat from "@/app/AIChat";
import NotificationPrimer from "@/app/NotificationPrimer";
import StrategicGoalPrompt from "@/app/StrategicGoalPrompt";
import { MessageSquare, X } from "lucide-react";

export default function CommandCenter() {
  useEffect(() => { track("command_center_view"); }, []);
  const [chatOpenMobile, setChatOpenMobile] = useState(false);

  // AI Chat can be opened from the mobile tab bar via a custom event.
  useEffect(() => {
    const onOpen = () => setChatOpenMobile(true);
    window.addEventListener("stupeco:open-ai-chat", onOpen);
    // ?ai=1 deep-link support
    if (typeof window !== "undefined" && new URLSearchParams(window.location.search).get("ai") === "1") {
      setChatOpenMobile(true);
    }
    return () => window.removeEventListener("stupeco:open-ai-chat", onOpen);
  }, []);

  return (
    <div className="space-y-5" data-testid="command-center">
      <Seo title="Command Center" description="Your StUpEco Workspace Command Center." path="/app" />

      <NotificationPrimer />
      <StrategicGoalPrompt />

      <div className="grid gap-5 xl:grid-cols-[minmax(0,1fr)_360px]">
        <div className="min-w-0 space-y-5">
          <BusinessBriefing />
          <WorkspacePulse />
          <CommandCenterAnalytics />
        </div>

        <aside className="hidden xl:block" data-testid="cc-ai-chat-aside">
          <div className="sticky top-4">
            <AIChat variant="compact" />
          </div>
        </aside>
      </div>

      <div className="xl:hidden">
        {!chatOpenMobile ? (
          <button
            onClick={() => setChatOpenMobile(true)}
            data-testid="cc-ai-chat-open"
            className="fixed bottom-24 right-4 z-30 inline-flex items-center gap-2 rounded-full brand-gradient-bg px-5 py-3 text-sm font-semibold text-white shadow-lg"
          >
            <MessageSquare className="h-4 w-4" /> Ask your AI
          </button>
        ) : (
          <div
            className="fixed inset-x-2 bottom-20 top-16 z-40 flex flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-xl"
            data-testid="cc-ai-chat-panel"
          >
            <div className="flex items-center justify-between border-b border-border px-4 py-2">
              <p className="text-sm font-semibold">Ask your AI</p>
              <button onClick={() => setChatOpenMobile(false)} data-testid="cc-ai-chat-close" className="text-muted-foreground hover:text-foreground">
                <X className="h-4 w-4" />
              </button>
            </div>
            <div className="min-h-0 flex-1 overflow-hidden">
              <AIChat variant="compact" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
